import http from 'hub-http/clients/apiClient';
export function fetchNativeIntegrationAppStatus(appId) {
  return http.get(`integrators/v1/portal-installs/native-statuses?appId=${encodeURIComponent(appId)}`).then(([{
    integrationStatus
  }]) => integrationStatus);
}